import React from 'react';
import { MEDICAL_EXAM_CATEGORIES } from '../../../constants/medicalExamCategories';
import MedicalExamCatalogManager from '../medicalExams/MedicalExamCatalogManager';

/** Page Head Doctor — référentiel des échographies. */
export default function HeadDoctorEchographiesPage() {
  return <MedicalExamCatalogManager categoryId={MEDICAL_EXAM_CATEGORIES.ULTRASOUND.id} />;
}
